import { BaseGetProvider } from '@tendercuts/http';
import { EndPoint } from '../base';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoginServices } from '../login/services';
import { SaleOrder } from '@tendercuts/models';

@Injectable()
export class OnlineOrderService extends BaseGetProvider<SaleOrder> {
  constructor(
    public http: HttpClient,
    public loginService: LoginServices,
    public endpointService: EndPoint
  ) {
    super(http);
    this.delegate = this;
  }

  get isCachable() {
    return false;
  }

  get isAuthenticatedEndpoint() {
    return true;
  }

  get authProtocol() {
    return this.loginService;
  }

  preProcessResponse(response) {
    return response.results;
  }

  get model() {
    return SaleOrder;
  }

  get endpoint() {
    return this.endpointService.onlineOrders();
  }
}
